var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action_container",attrs:{"href":_vm.link,"target":"_blank","download":""}},[_vm._m(0),_vm._v(" Download ")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"action_icon"},[_c('img',{attrs:{"src":require("@/assets/images/download.svg")}})])
}]

export { render, staticRenderFns }